import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = /*#__PURE__*/_createVNode("label", {
  for: "goal",
  class: "leading-7 text-sm font-medium text-gray-500"
}, " 学習科目（複数選択可） ", -1)
const _hoisted_3 = { class: "p-3 rounded-md bg-white text-sm text-gray-400" }
const _hoisted_4 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "text-gray-400 font-medium" }, "主要科目", -1)
const _hoisted_6 = { class: "flex flex-wrap mt-1" }
const _hoisted_7 = {
  key: 1,
  class: "mb-2"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "text-gray-400 font-medium" }, "主要科目", -1)
const _hoisted_9 = { class: "flex flex-wrap mt-1" }
const _hoisted_10 = {
  key: 2,
  class: "mb-2"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "text-gray-400 font-medium" }, "主要科目", -1)
const _hoisted_12 = { class: "flex flex-wrap mt-1" }
const _hoisted_13 = {
  key: 3,
  class: "mb-2"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "text-gray-400 font-medium" }, "理科", -1)
const _hoisted_15 = { class: "flex flex-wrap mt-1" }
const _hoisted_16 = {
  key: 4,
  class: "mb-2"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "text-gray-400 font-medium" }, "社会", -1)
const _hoisted_18 = { class: "flex flex-wrap mt-1" }
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "text-gray-400 font-medium" }, "その他", -1)
const _hoisted_20 = { class: "flex flex-wrap mt-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      (_ctx.isElementary)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _hoisted_5,
            _createVNode("div", _hoisted_6, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.elementarySubjects, (subjectName) => {
                return (_openBlock(), _createBlock("div", {
                  key: subjectName,
                  class: ["px-3 py-1 mr-3 mb-2 border rounded-full transition-colors duration-300 cursor-pointer", _ctx.dynamicSubjectCss(subjectName)],
                  onClick: ($event: any) => (_ctx.select(subjectName))
                }, _toDisplayString(subjectName), 11, ["onClick"]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isJuniorHigh)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _hoisted_8,
            _createVNode("div", _hoisted_9, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.juniorSubjects, (subjectName) => {
                return (_openBlock(), _createBlock("div", {
                  key: subjectName,
                  class: ["px-3 py-1 mr-3 mb-2 border rounded-full transition-colors duration-300 cursor-pointer", _ctx.dynamicSubjectCss(subjectName)],
                  onClick: ($event: any) => (_ctx.select(subjectName))
                }, _toDisplayString(subjectName), 11, ["onClick"]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isHigh)
        ? (_openBlock(), _createBlock("div", _hoisted_10, [
            _hoisted_11,
            _createVNode("div", _hoisted_12, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.highNormalSubjects, (subjectName) => {
                return (_openBlock(), _createBlock("div", {
                  key: subjectName,
                  class: ["px-3 py-1 mr-3 mb-2 border rounded-full transition-colors duration-300 cursor-pointer", _ctx.dynamicSubjectCss(subjectName)],
                  onClick: ($event: any) => (_ctx.select(subjectName))
                }, _toDisplayString(subjectName), 11, ["onClick"]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isHigh)
        ? (_openBlock(), _createBlock("div", _hoisted_13, [
            _hoisted_14,
            _createVNode("div", _hoisted_15, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.highScienceSubjects, (subjectName) => {
                return (_openBlock(), _createBlock("div", {
                  key: subjectName,
                  class: ["px-3 py-1 mr-3 mb-2 border rounded-full transition-colors duration-300 cursor-pointer", _ctx.dynamicSubjectCss(subjectName)],
                  onClick: ($event: any) => (_ctx.select(subjectName))
                }, _toDisplayString(subjectName), 11, ["onClick"]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isHigh)
        ? (_openBlock(), _createBlock("div", _hoisted_16, [
            _hoisted_17,
            _createVNode("div", _hoisted_18, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.highSocialSubjects, (subjectName) => {
                return (_openBlock(), _createBlock("div", {
                  key: subjectName,
                  class: ["px-3 py-1 mr-3 mb-2 border rounded-full transition-colors duration-300 cursor-pointer", _ctx.dynamicSubjectCss(subjectName)],
                  onClick: ($event: any) => (_ctx.select(subjectName))
                }, _toDisplayString(subjectName), 11, ["onClick"]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", null, [
        _hoisted_19,
        _createVNode("div", _hoisted_20, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.otherSubjects, (subjectName) => {
            return (_openBlock(), _createBlock("div", {
              key: subjectName,
              class: ["px-3 py-1 mr-3 mb-2 border rounded-full transition-colors duration-300 cursor-pointer", _ctx.dynamicSubjectCss(subjectName)],
              onClick: ($event: any) => (_ctx.select(subjectName))
            }, _toDisplayString(subjectName), 11, ["onClick"]))
          }), 128))
        ])
      ])
    ])
  ]))
}